import React, { Fragment, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import {
  Button,
  Input,
  Password,
  LoginLayout,
  Radio,
  CheckBox,
} from "@app/components";
import {
  FormFlexWrapper,
  DropdownWrapper,
  SelectCustomStyles,
  FlexWrapper,
  Error,
  CommonLabel,
  FormGroup,
  FormGroupWrapper
} from "@app/components/commonStyles";
import { validateEmail, getAddress, validateOtp, sendOtp, sendAuthEmail } from "@app/services";
import { privacyUrl, termsUrl, ambassadorUrl } from "@app/routes/route-helpers";
import {
  stateList,
  emailPattern,
  passwordPattern,
  accountTypeList,
  useLocation,
  formatPhoneNumber,
  capitalize,
  numberPattern,
} from "@app/utils";
import { ButtonContainer, Container, RadioGroup } from "../sign-up.component";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
type Props = {
  submitData: (e: any) => void;
  buttonText: string;
  updateButtonText: (e: any) => void;
  accountType: string;
  updateAccountType: (e: any) => void;
  setEmailError: (e: any) => void;
  zipError: boolean;
  phoneError: boolean;
  setZipError: (e: any) => void;
  setPhoneError: (e: any) => void;
  SendData: (e: any) => void;
  ValidateOtp: (e: any) => void;
  UserData: any;
  failCount: any;
  countryCodeNum: (e: any) => void;
  countryCode: any;
  // showPhoneInputErr:any

};

export default function EducatorSignup({
  submitData,
  buttonText,
  updateButtonText,
  accountType,
  updateAccountType,
  setEmailError,
  zipError,
  setZipError,
  phoneError,
  setPhoneError,
  SendData,
  ValidateOtp,
  UserData,
  failCount,
  countryCodeNum,
  countryCode

}: Props) {
  const {
    register,
    watch,
    handleSubmit,
    errors,
    unregister,
    trigger,
    getValues,
    control,
    setValue,
    clearErrors,
  }: any = useForm({
    mode: "onBlur",
  });

  const { navigate } = useLocation();
  const [emailValidation, SetEmailValidation] = useState<any>({
    isEmailValid: false,
    validate: false,
    emailError: false,
  });
  const [UserData1, setUserData1] = useState<any>(
    {
      // userType: "educator",
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
      city: '',
      state: '',
      zip: '',
      // educatorLicenseType: accountType,
      password: '',
      confirmPassword: '',
      // kazooAmbassador: data.ambassador ? 1 : 0,
      // termsOfService: 1,
    })

  const [zipServerErr, setZipServerErr] = useState('');
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(false);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [checkedTerms, setCheckedTerms] = useState<boolean>(false);
  const [checkedErr, setCheckedErr] = useState<boolean>(false);
  // function checkboxBlur() {
  //   if (isChecked === true) {
  //     clearErrors("termsOfService")
  //   }

  // if(!isChecked){
  //   clearErrors("termsOfService")
  // }
  // setIsChecked(!isChecked)
  // }



  function onPasswordBlur(evt: any) {
    if (getValues("confirmPassword")) {
      trigger("confirmPassword");
    }
    if (passwordPattern.test(evt.target.value)) {
      clearErrors("password")
    }
  }
  function onConfirmPassBlur(evt: any) {
    if (passwordPattern.test(evt.target.value)) {
      clearErrors("confirmPassword")
    }
  }
  useEffect(() => {
    if (UserData) {
      for (const [key, value] of Object.entries(UserData)) {
        setValue(key, value);
        if (failCount == 0) {
          setValue(key, '')
        }
      }
      setValue('password', '');
      setValue('confirmPassword', '');
      setValue('termsOfService', false)
    }
  }, [])
  function onEmailBlur() {
    const emailValue = getValues("email");
    if (emailValue) {
      SetEmailValidation({ ...emailValidation, validate: true });
      validateEmail({ email: emailValue })
        .then((response: any) => {
          if (response._responseStatus === 1) {
            setEmailError(false);
            SetEmailValidation({
              isEmailValid: true,
              validate: false,
              emailError: false,
            });
          } else {
            setEmailError(true);
            SetEmailValidation({
              isEmailValid: false,
              validate: false,
              emailError: true,
            });
          }
        })
        .catch((err: any) => {
          setEmailError(false);
          SetEmailValidation({
            isEmailValid: false,
            validate: false,
            emailError: true,
          });
          console.log(err);
        });
    }
  }

  function onChange(data: any) {
    if (data.target.name === "accountType") {
      updateAccountType(data.target.value);
      if (data.target.value === "school/district") {
        updateButtonText("Continue");
      } else {
        updateButtonText("Sign Up");
      }
    }
    if (data.target.name === "phoneNumber") {
      const actual_val = formatPhoneNumber(data.target.value);
      setValue("phoneNumber", actual_val);
      if (actual_val.length === 14) {
        setPhoneError(false);
      }
    }
    if (data.target.name === "zip") {
      setValue("city", "");
      setValue("state", "");
      if (data.target.value.length === 5) {
        setZipError(false);
      }
    }
  }

  function onPhoneBlur(evt: any) {
    if (evt.length >= 11) {
      clearErrors("phoneNumber")
      setPhoneError(false);
    } else {
      setPhoneError(true);
    }
  }
  function onZipBlur(data: any) {
    setZipServerErr('')
    if (data.target.value.length !== 5) {
      setZipError(true);
      return;
    }
    setZipError(false);
    getAddress(data.target.value)
      .then((res) => {
        if (res && !res.error) {
          setValue("city", capitalize(res.city));
          clearErrors("city");
          const selectedState = stateList.find(
            (state) => state.value === res.state
          );
          setValue("state", selectedState);
          clearErrors("state");
        }
        else {
          setZipServerErr(res.error)
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  function navigateToSignup() {
    navigate("/sign-up");
  }


  const SendOtp = (data: any) => {
    // console.log(data)
    // UserData1['firstName'] = data.firstName;
    // UserData1['lastName'] = data.lastName;
    // data['phoneNumber']= countryCode.concat(data.phoneNumber)
    // console.log(data.phoneNumber)
    // showPhoneInputErr(false)
    // console.log(countryCodeNum)
    // if(!countryCodeNum){
    //   showPhoneInputErr(true)
    setCheckedErr(false)
    const params: any = {}
    Object.assign(params, {
      termsOfService: checkedTerms || false,
      ...data
    })
    // console.log(params)
    if (params.termsOfService === false) {
      setCheckedErr(true)
      return false
    }
    if (checkedTerms == false) {
      return false
    }
    else {
      SendData(data)
      setUserData1(data)
    }

    // setValue('firstName', data.firstName)
  }

  // const HandlePhoneNum=(data:any)=>{
  //   console.log(data)
  //   showPhoneInputErr(true)
  // }


  // const HandleChange =(evt:any)=>{
  // if(evt.target.name === "firstName"){
  //   const list ={...UserData1}
  //   UserData1['firstName']=evt.target.value
  // }
  // if(evt.target.name === "lastName"){
  //   const list ={...UserData1}
  //   UserData1['lastName']=evt.target.value
  // }
  // }

  // const HandleChange =(evt:any)=>{
  // if(evt.target.name === "firstName"){
  //   const list ={...UserData1}
  //   UserData1['firstName']=evt.target.value
  // }
  // if(evt.target.name === "lastName"){
  //   const list ={...UserData1}
  //   UserData1['lastName']=evt.target.value
  // }
  // }
  // const [is_Checked,setIsChecked]=useState<boolean>(true)
  // const toggleChecked =()=>{
  //   setIsChecked(!is_Checked)
  // }

  return (
    <LoginLayout path="" label="">
      <Container>
        <h3 className="primary-header text-center mb-3">
          Sign up as Educator/School
        </h3>
        <form onSubmit={handleSubmit(SendOtp)} onChange={onChange}>
          <FormGroupWrapper>
            <FormGroup>
              <FormFlexWrapper className="two-child-layout mb-0">
                <div className="child mb-0">
                  <Input
                    hideLabel={false}
                    label="First Name"
                    placeholder="First Name"
                    name="firstName"

                    // onChange={HandleChange}
                    register={register({
                      required: true,
                      validate: (value: any) => {
                        return value.trim().length > 0;
                      },
                    })
                    }
                    error={errors.firstName && "Please enter First Name"}
                  />
                </div>
                <div className="child">
                  <Input
                    hideLabel={false}
                    label="Last Name"
                    placeholder="Last Name"
                    name="lastName"
                    register={register({
                      required: true,
                      validate: (value: any) => {
                        return value.trim().length > 0;
                      },
                    })}
                    error={errors.lastName && "Please enter Last Name"}
                  />
                </div>
              </FormFlexWrapper>
              <FormFlexWrapper className="two-child-layout mb-0">
                <div className="child mb-0">
                  <div style={{ marginBottom: '16px' }}>
                    <CommonLabel className="label-color">Phone Number</CommonLabel>
                    <Controller
                      name="phoneNumber"
                      control={control}
                      rules={{
                        required: true,
                        //   minLength:11,
                        // maxLength:15 ,
                        // pattern:numberPattern
                      }}
                      render={({ onChange, value }) => (
                        <PhoneInput
                          value={getValues().phoneNumber}
                          // defaultMask={cou}
                          //  name="phoneNumber"
                          onChange={(evt) => {
                            countryCodeNum(evt);
                            onPhoneBlur(evt)
                            setValue('phoneNumber', evt)
                            // console.log(evt)

                            // showPhoneInputErr(false)
                            // setPhoneError(true)
                          }}
                          // defaultMask={}
                          country={"us"}
                          preferredCountries={["us", "in", "uk", "nz", "au", "ca"]}
                          autoFormat={true}
                          placeholder="Phone Number"
                          specialLabel="Phone Number"
                        // onBlur={onPhoneBlur}
                        />

                      )}
                    />

                    {
                      errors.phoneNumber && <Error>Please enter Phone Number</Error> ||
                      (!errors.phoneNumber && phoneError && <Error>Please enter valid Phone Number</Error>)
                    }
                  </div>
                  {/* <Input
                    hideLabel={false}
                    type="number"
                    label="Phone Number"
                    placeholder="Phone Number"
                    name="phoneNumber"
                    maxLength={14}
                    defaultValue={UserData1.phoneNumber}
                    register={register({
                      required: true,
                      validate: (value: any) => {
                        return value.trim().length > 0;
                      },
                    })}
                    onBlur={onPhoneBlur}
                    error={
                      (errors.phoneNumber && "Please enter Phone Number") ||
                      (!errors.phoneNumber &&
                        phoneError &&
                        "Please enter valid Phone Number")
                    }
                  /> */}
                </div>
                <div className="child">
                  <Input
                    hideLabel={false}
                    type="number"
                    label="Zip Code"
                    placeholder="Zip Code"
                    name="zip"
                    register={register({
                      required: true,
                      validate: (value: any) => {
                        return value.trim().length > 0;
                      },
                    })}
                    maxLength={5}
                    onChange={onZipBlur}
                    error={
                      (errors.zip && "Please enter Zip Code") ||
                      (!errors.zip && zipError && "Please enter valid Zip Code") ||
                      zipServerErr
                    }
                  />
                </div>
              </FormFlexWrapper>
              <FormFlexWrapper className="two-child-layout">
                <div className="child mb-0">
                  <Input
                    hideLabel={false}
                    label="City"
                    placeholder="City"
                    name="city"
                    register={register({
                      required: true,
                      validate: (value: any) => {
                        return value.trim().length > 0;
                      },
                    })}
                    error={errors.city && "Please enter City"}
                  />
                </div>
                <div className="child">
                  <DropdownWrapper>
                    <CommonLabel className="label-color">State</CommonLabel>
                    <Controller
                      as={Select}
                      value="value"
                      name="state"
                      options={stateList}
                      placeholder="State"
                      control={control}
                      rules={{ required: true }}
                      styles={SelectCustomStyles}
                      defaultValue={""}
                    />
                    {errors.state && <Error>Please select State</Error>}
                  </DropdownWrapper>
                </div>
              </FormFlexWrapper>
              <FormFlexWrapper className="mb-0">
                <div className="child only-child">
                  <CommonLabel className="mb-2">Account Type</CommonLabel>
                  <RadioGroup>
                    {accountTypeList.map((each: any) => (
                      <Radio
                        name="accountType"
                        value={each.value}
                        key={each.value}
                        checked={each.value === accountType}
                        register={register({
                          required: true,
                        })}
                        id={"account_" + each.value}
                        label={each.label}
                        text={each.text}
                      />
                    ))}
                  </RadioGroup>
                  {errors.accountType && (
                    <Error>Please select Account Type</Error>
                  )}
                </div>
              </FormFlexWrapper>
            </FormGroup>
            <FormGroup>
              <FormFlexWrapper
                className={accountType !== "school/district" ? "mb-0" : ""}
              >
                <div className="child only-child">
                  <Input
                    hideLabel={false}
                    type="email"
                    label="Email Address"
                    placeholder="Email Address"
                    name="email"
                    register={register({
                      required: true,
                      pattern: emailPattern,
                    })}
                    onBlur={onEmailBlur}
                    className={
                      !errors.email && emailValidation.isEmailValid
                        ? "valid"
                        : ""
                    }
                    isValid={
                      !errors.email &&
                      !emailValidation.validate &&
                      emailValidation.isEmailValid
                    }
                    validating={!errors.email && emailValidation.validate}
                    error={
                      (errors.email &&
                        errors.email.type === "required" &&
                        "Please enter Email Address") ||
                      (errors.email &&
                        errors.email.type === "pattern" &&
                        "Please enter valid Email Address") ||
                      (!errors.email &&
                        emailValidation.emailError &&
                        "Email already exists. Please try with another Email.")
                    }
                  />
                </div>
              </FormFlexWrapper>
              {accountType !== "school/district" && (
                <Fragment>
                  <FormFlexWrapper className="mb-0">
                    <div className="child only-child">
                      <Password
                        label="Password"
                        hideLabel={false}
                        hideIcon={true}
                        placeholder="Password"
                        name="password"
                        showInstructions={true}
                        register={register({
                          required: true,
                          pattern: passwordPattern,
                        })}
                        onChange={onPasswordBlur}
                        error={
                          (errors.password &&
                            errors.password.type === "required" &&
                            "Please enter Password") ||
                          (errors.password &&
                            errors.password.type === "pattern" &&
                            "Please enter a Strong Password")
                        }
                      />
                    </div>
                  </FormFlexWrapper>
                  <FormFlexWrapper>
                    <div className="child only-child">
                      <Password
                        label="Confirm Password"
                        hideIcon={true}
                        hideLabel={false}
                        placeholder="Confirm Password"
                        name="confirmPassword"
                        onChange={onConfirmPassBlur}
                        register={register({
                          required: true,
                          validate: (value: any) => {
                            return value === watch("password");
                          },
                        })}
                        error={
                          (errors.confirmPassword &&
                            errors.confirmPassword.type === "required" &&
                            "Please confirm Password") ||
                          (errors.confirmPassword &&
                            errors.confirmPassword.type === "validate" &&
                            "Passwords did not match")
                        }
                      />
                    </div>
                  </FormFlexWrapper>
                </Fragment>
              )}
              <FormFlexWrapper className="mb-1">
                <div className="child only-child">
                  <CheckBox
                    name="ambassdor"
                    value="true"
                    register={register({})}
                    defaultChecked={!isChecked}
                  >
                    I'd like to become a
                    <a
                      href={ambassadorUrl}
                      rel="noopener noreferrer"
                      className="anchor-tag"
                    > KazooBadoo Ambassador
                    </a>
                  </CheckBox>
                </div>
              </FormFlexWrapper>


              <FormFlexWrapper className="mb-3">
                <div className="child only-child">
                  {/* <input 
                   type="checkbox" name="termsAndConditions" checked={true}
                  //  style={{border:"1px solid #000",width:"18px",height:"18px"}}
                   ref={register({reuired:true})}
                  //  className="checkmark"
                   onChange={()=>{
                    setCheckedTerms(!checkedTerms)
                   }}
                   /> */}
                  <label className="custom-checkbox-container mb-0">
                    <input type="checkbox"
                      ref={register({})}
                      name="termsOfService"
                      onChange={() => {
                        setCheckedTerms(!checkedTerms)
                      }}
                      // defaultChecked={checkedTerms}
                      value={""} />
                    <span className="checkmark"></span>
                    <span>I agree to KazooBadoo's</span>
                    <a
                      href={termsUrl}
                      rel="noopener noreferrer"
                      className="anchor-tag"
                    > Terms of Use
                    </a> and
                    <a
                      href={privacyUrl}
                      rel="noopener noreferrer"
                      className="anchor-tag"
                    > Privacy Policy
                    </a>
                  </label>
                  {checkedErr && checkedTerms === false && (
                    <Error className="checkbox-error">
                      You need to agree Terms of Use and Privacy Policy
                    </Error>
                  )}
                  {/* <CheckBox
                    name="termsOfService"
                    register={register({ validate: (value: any) => value === true })}
                  // defaultChecked={false}
                  // value="true"
                  // onChange={(evt:any)=>{
                  //   console.log(evt.target.checked,"ddd")
                  //   setValue('termsOfService',evt.target.checked)
                  // }}
                  >
                    I agree to KazooBadoo's
                    <a
                      target="_blank"
                      href={termsUrl}
                      rel="noopener noreferrer"
                      className="anchor-tag"
                    >
                      Terms of Use
                    </a>
                    and
                    <a
                      target="_blank"
                      href={privacyUrl}
                      rel="noopener noreferrer"
                      className="anchor-tag"
                    >
                      Privacy Policy
                    </a>
                  </CheckBox> */}
                  {/* {console.log(errors.termsOfService) } */}
                  {/* {console.log(getValues().termsOfService) } */}

                  {errors.termsOfService && (
                    <Error className="checkbox-error">
                      You need to agree Terms of Use and Privacy Policy
                    </Error>
                  )}
                </div>
              </FormFlexWrapper>
            </FormGroup>
          </FormGroupWrapper>
          <ButtonContainer disabled={buttonText === "Signing Up..."}>
            <Button
              variant="newsecondary"
              size="large"
              width="100%"
              type="submit"
              onClick={() => {
                if (checkedTerms === false) {
                  setCheckedErr(true)
                }
              }}
            // onClick={HandlePhoneNum}
            >
              {buttonText}
            </Button>
          </ButtonContainer>
          <ButtonContainer style={{ marginTop: "15px" }}>
            <Button onClick={() => navigateToSignup()}
              variant="bordered"
              size="large"
              width='100%'>
              Cancel
            </Button>
          </ButtonContainer>
        </form>
        {accountType !== "school/district" && (
          <FlexWrapper className="justify-between mt-2">
            <p className="m-0">
              Already have an account?
              <button
                className="anchor-tag"
                type="button"
                onClick={() => navigate("/sign-in/educator")}
              >
                Sign In
              </button>
            </p>
          </FlexWrapper>
        )}
      </Container>
    </LoginLayout>
  );
}
